<script lang="ts">
  // libs
  import { convertToDistributorDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import TransferBreakdown from "@distributor/svelte/Payments/TransferBreakdown.svelte";
  import RetailerDisplayName from "@distributor/svelte/Payments/RetailerDisplayName.svelte";

  // types
  import type { PaymentTransferType } from "@shared/types/Invoice";

  // props
  export let payment: PaymentTransferType;
  export let toggleRow: (type: Event) => any;

  // data
  let paymentStatusClass = {
    pending: "fizz-pill-yellow",
    settled: "fizz-pill-green",
    failed: "fizz-pill-red",
    canceled: "fizz-pill-red",
  };
</script>

<tr id="payment_transaction_{payment.id}" class="payment-transfer-row">
  <td data-label="Account">
    {#key payment.id}
      <RetailerDisplayName {payment} />
    {/key}
  </td>
  <td data-label="Transaction Date">
    {convertToDistributorDate(payment.created_at)}
  </td>
  <td data-label="Status">
    <span class={paymentStatusClass[payment.settlement_status]}>
      {payment.settlement_status.charAt(0).toUpperCase() + payment.settlement_status.slice(1)}
    </span>
  </td>
  <td data-label="Settlement Date">
    {#if payment.date_settled}
      {convertToDistributorDate(payment.date_settled)}
    {/if}
  </td>
  <td data-label="Invoice">{payment.payment_invoice.invoice_reference_id}</td>
  {#if payment.payment_confirmation}
    <td data-label="Payment Confirmation Code">{payment.payment_confirmation.confirmation_code}</td>
  {:else}
    <td />
  {/if}
  <td data-label="Amount" class="fizz-align-right">
    {#if payment.settlement_status === "settled"}
      <FormatMoney input={payment.net_amount} formatType={"5"} />
    {:else if payment.settlement_status === "failed"}
      <FormatMoney input={-1 * payment.net_amount} formatType={"5"} />
    {:else}
      Pending
    {/if}
  </td>
  <td>
    <div
      class="fizz-table-menu"
      data-testid={`payment_detail_toggle_${payment.id}`}
      id={`payment_detail_toggle_${payment.id}`}
    >
      <button class="fizz-icon-button-small" on:click={event => toggleRow(event)}>
        <svg viewBox="0 0 32 32" id="icon-chevron-down" class="fizz-icon-16 fizz-text-brand">
          <path d="M24.4 8.4L16 16.6 7.6 8.4 4 11.9l12 11.7 12-11.7z" />
        </svg>
      </button>
    </div>
  </td>
</tr>
<tr id="payment_transaction_info_{payment.id}" class="fizz-is-hidden">
  <td colspan="7" class="fizz-text-right">
    <dl class="fizz-flow-16" style="max-width: 300px; margin-left: auto;">
      <TransferBreakdown {payment} />
    </dl>
  </td>
  <td />
</tr>
